'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var calculateBreakPointWidth = exports.calculateBreakPointWidth = function calculateBreakPointWidth(gutter, columnCount) {
	if (columnCount <= 1) {
		return 'calc(100%);';
	}

	if (columnCount === 2) {
		return 'calc(' + 100 / columnCount + '% - ' + gutter / columnCount + 'px);';
	}

	return 'calc(' + 100 / columnCount + '% - ' + Math.ceil(Math.abs(gutter) / columnCount * (columnCount - 1)) + 'px);';
};

var calculateCellWidth = exports.calculateCellWidth = function calculateCellWidth(gutter, width) {
	if (width === 'full') {
		return 'calc(100%);';
	}

	return 'calc(' + width / 12 * 100 + '% - ' + gutter + 'px);';
};

var parseNumber = exports.parseNumber = function parseNumber(num, def) {
	return parseInt(num, 10) || def;
};